import { render, staticRenderFns } from "./DocumentFlow.vue?vue&type=template&id=4ccaaf06&scoped=true"
import script from "./DocumentFlow.vue?vue&type=script&lang=ts"
export * from "./DocumentFlow.vue?vue&type=script&lang=ts"
import style0 from "./DocumentFlow.vue?vue&type=style&index=0&id=4ccaaf06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccaaf06",
  null
  
)

export default component.exports